import { Grid, InputLabel, Box, Tooltip } from '@mui/material';
import { IFormController } from '../types';
import InfoIcon from '@mui/icons-material/Info';
import Theme from '../../../Themes/main.theme';
import React from 'react';
import { MuiTelInput } from 'mui-tel-input';

const TelInput = (props: IFormController) => {
  const { label, name, formik, required, info, ...rest } = props;

  const [value, setValue] = React.useState(formik?.values[name] || '');

  const handleChange = (newValue: string) => {   
    setValue(newValue);
    formik?.setFieldValue(name, newValue);    
  };

  React.useEffect(() => {
    setValue(formik?.values[name] || '');
  }, [formik?.initialValues[name]]);
  
  return (
    <Grid>
      <Grid>
        <Box>
          <Box display='flex' alignItems='center'>
            <InputLabel
              disabled={props.disabled}
              htmlFor={name}
              required={required}
              sx={{
                my: 2,
                textAlign: 'left',
                textStyle: 'none',
              }}
            >
              {label}
            </InputLabel>
            {info ? 
              <Tooltip
                PopperProps={{
                  disablePortal: true
                }} title={props?.tooltip}
                placement='right-start'>
                <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '17px'}}/>
              </Tooltip>
              : null
            }
          </Box>
          <MuiTelInput
            disableFormatting
            fullWidth
            defaultCountry='GR'
            MenuProps={{disablePortal: true}}
            id={name}
            {...formik?.getFieldProps(`${name}`)}
            {...rest}
            value={value} 
            onChange={handleChange}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default TelInput;